import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, defineMessages } from 'react-intl';

import { Segment, Grid, Icon, Image, Label } from 'semantic-ui-react';
import { Checkbox, Tooltip } from 'material-ui';

import { InfectionPC } from 'components';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import styles from './ExamListItem.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamListItemAll extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { indexNo, itemNo, examListData, examSummaryData, selectedExamList, checkboxHide } = this.props;
    // function
    const { handleSelectExamList, handleCheckExamList } = this.props;

    let SendTitle =
      defineMessages(formatMessage({ id: 'ExamListItem_4', defaultMessage: '발송' })) + ': ' + examListData.get('send');
    if (!!examListData.get('sendError')) {
      SendTitle +=
        ' / ' +
        defineMessages(formatMessage({ id: 'ExamDetailTag_48', defaultMessage: '실패' })) +
        ': ' +
        examListData.get('sendError');
    }
    // 발송 예약
    if (!!examListData.get('sendReserve')) {
      SendTitle +=
        ' / ' +
        defineMessages(formatMessage({ id: 'ExamListItem_25', defaultMessage: '발송 예약' })) +
        ': ' +
        examListData.get('sendReserve');
    }
    // 메일 발송 일시정지
    if (examSummaryData.get('isSuspend') === 1) {
      SendTitle =
        '(' +
        defineMessages(formatMessage({ id: 'ExamSummaryItem_16', defaultMessage: '메일 발송 일시정지' })) +
        ') ' +
        SendTitle;
    }

    // 치료 사용 여부
    const isCure =
      1 === examSummaryData.get('examType') && 2 === examSummaryData.getIn(['attachData', 'attachExamType'])
        ? true
        : false;
    // 링크첨부 여부
    const isLink = 2 & examSummaryData.get('linkAttach') ? true : false;
    // 피싱 유도 템플릿 여부
    const isPhishing = 4 === examSummaryData.get('examType') ? true : false;
    // 피싱 안내 템플릿 여부
    const isPhishingDirect = 5 === examSummaryData.get('examType') ? true : false;

    // 신고 대상자 수
    let declareCount = defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' }));
    if (examListData.get('declare') > 0) {
      if (examListData.get('declare') > 999) {
        declareCount = '+999';
      } else {
        declareCount =
          examListData.get('declare') + defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }));
      }
    }

    // 연결된 교육 수
    let eduCount = defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' }));
    if (examListData.get('edu') > 0) {
      if (examListData.get('edu') > 999) {
        eduCount = '+999';
      } else {
        eduCount =
          examListData.get('edu') + defineMessages(formatMessage({ id: 'ExamListItem_10', defaultMessage: '개' }));
      }
    }

    const InnerComponent = (
      <Grid.Row className={cx('examTotal')} textAlign="center">
        {!checkboxHide && <Grid.Column className={cx('cell-checkBox')}>
          <Checkbox
            checkedIcon={<Image src="/img/exam/list_check_on.png" />}
            className={cx('examListItem-checkBox')}
            checked={
              selectedExamList.get('isType') === 'check' && selectedExamList.get('noArray').indexOf(itemNo) !== -1
                ? true
                : false
            }
          />
        </Grid.Column>}
        <Grid.Column className={cx('cell-examName')} textAlign="left">
          <Tooltip
            title={
              defineMessages(formatMessage({ id: 'ExamListItem_1', defaultMessage: '훈련명' })) +
              ': ' +
              examListData.get('examName')
            }
            classes={{ tooltip: 'tooltip-noMaxWidth' }}
            placement="bottom-start">
            <div className={cx('ml-5', 'ellipsis')}>{examListData.get('examName')}</div>
          </Tooltip>
        </Grid.Column>
        <Grid.Column className={cx('cell-examPeriod')}>
          <Tooltip
            title={
              !!examSummaryData &&
              defineMessages(formatMessage({ id: 'ExamListItem_2', defaultMessage: '훈련 기간' })) +
              ': ' +
              common.timeFormatFromUTCEpoch(examSummaryData.get('examStartEpoch'), 3) +
              ' ~ ' +
              common.timeFormatFromUTCEpoch(examSummaryData.get('examEndEpoch'), 3)
            }
            classes={{ tooltip: 'tooltip-noMaxWidth' }}
            placement="bottom">
            <div className={cx('examPeriod-date')}>
              {!!examSummaryData &&
                common.timeFormatFromUTCEpoch(examSummaryData.get('examStartEpoch'), 3) +
                ' ~ ' +
                common.timeFormatFromUTCEpoch(examSummaryData.get('examEndEpoch'), 3)}
            </div>
          </Tooltip>
        </Grid.Column>
        <Grid.Column className={cx('cell-infection')}>
          <div className={cx('examItem')}>
            <Tooltip
              title={
                defineMessages(formatMessage({ id: 'ExamListItem_3', defaultMessage: '대상' })) +
                ': ' +
                examListData.get('target')
              }
              placement="bottom">
              <div className={cx('examItem-set')}>
                <Image src="/img/exam/list_target.png" />
                <span className={cx('examItem-count')}>{examListData.get('target')}</span>
              </div>
            </Tooltip>
            <Tooltip title={SendTitle} classes={{ tooltip: 'tooltip-noMaxWidth' }} placement="bottom">
              <div className={cx('examItem-set', { 'color-red': !!examListData.get('sendError') })}>
                {/* 메일 발송 일시 정지 */}
                {examListData.get('isSuspend') === 1 ? (
                  <Image src="/img/exam/list_send_stop.png" />
                ) : !!examListData.get('sendError') ? (
                  // 메일 발송 실패 있음
                  <Image src="/img/exam/list_send_fail.png" />
                ) : (
                      // 메일 발송
                      <Image src="/img/exam/list_send.png" />
                    )}
                <span className={cx('examItem-count')}>{examListData.get('send')}</span>
              </div>
            </Tooltip>
            <Tooltip
              title={
                defineMessages(formatMessage({ id: 'ExamListItem_5', defaultMessage: '열람' })) +
                ': ' +
                examListData.get('read')
              }
              placement="bottom">
              <div className={cx('examItem-set', 'color-orange')}>
                <Image src="/img/exam/list_read.png" />
                <span className={cx('examItem-count')}>{examListData.get('read')}</span>
              </div>
            </Tooltip>
            <Tooltip
              title={
                (isPhishing || isPhishingDirect
                  ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
                  : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))) +
                ': ' +
                (isLink || isPhishing || isPhishingDirect
                  ? examListData.get('download')
                  : defineMessages(formatMessage({ id: 'ExamListItem_24', defaultMessage: '사용 안함' })))
              }
              placement="bottom">
              <div className={cx('examItem-set', { 'color-down': isLink || isPhishing || isPhishingDirect })}>
                {isPhishing || isPhishingDirect ? (
                  <Image src={'/img/exam/list_access.png'} />
                ) : (
                  <Image src={isLink ? '/img/exam/list_down.png' : '/img/exam/list_down_grey.png'} />
                )}
                <span className={cx('examItem-count')}>
                  {isLink || isPhishing || isPhishingDirect ? examListData.get('download') : '-'}
                </span>
              </div>
            </Tooltip>
            <Tooltip
              title={
                (
                  isPhishing ? (
                    defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' })) + ': ' + examListData.get('infection')
                  ) : (
                      isPhishingDirect ? (
                        defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' })) + ': ' +
                        defineMessages(formatMessage({ id: 'ExamListItem_24', defaultMessage: '사용 안함' }))
                      ) : (
                          defineMessages(formatMessage({ id: 'ExamListItem_6', defaultMessage: '감염' })) + ': ' + examListData.get('infection')
                        )
                    )
                )
              }
              placement="bottom">
              <div className={cx('examItem-set', { 'color-red': !isPhishingDirect })}>
                {isPhishing ? (
                  <Image src="/img/exam/list_phishing.png" />
                ) : isPhishingDirect ? (
                  <Image src="/img/exam/list_phishing_grey.png" />
                ) : (
                      <Image src="/img/exam/list_infection.png" />
                    )}
                <span className={cx('examItem-count')}>{isPhishingDirect ? '-' : examListData.get('infection')}</span>
              </div>
            </Tooltip>
            <Tooltip
              title={
                defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' })) +
                ': ' +
                (isCure
                  ? examListData.get('cure')
                  : defineMessages(formatMessage({ id: 'ExamListItem_24', defaultMessage: '사용 안함' })))
              }
              placement="bottom">
              <div
                className={cx('examItem-set', {
                  'color-cure': isCure
                })}>
                <Image src={isCure ? '/img/exam/list_cure.png' : '/img/exam/list_cure_grey.png'} />
                <span className={cx('examItem-count')}>{isCure ? examListData.get('cure') : '-'}</span>
              </div>
            </Tooltip>
          </div>
        </Grid.Column>
        <Grid.Column className={cx('cell-infectionPc')}>
          {isPhishing || isPhishingDirect ? (
            <div />
          ) : (
              <div className={cx('infectionPc-area')}>
                <InfectionPC
                  pcCount={examListData.get('infectionPc')}
                  leakCount={examListData.get('leakAllcount')}
                  leakSize={common.fileSizeTrans(examListData.get('leakAllsize')).common}
                />

                {/* <div className={cx('pcSub-set')}>
                <Tooltip
                  title={
                    defineMessages(formatMessage({ id: 'ExamListItem_9', defaultMessage: '감염 가능한 전체 파일' })) +
                    ': ' +
                    examListData.get('leakAllcount') +
                    defineMessages(formatMessage({ id: 'ExamListItem_10', defaultMessage: '개' })) +
                    ' (' +
                    common.fileSizeTrans(examListData.get('leakAllsize')).common +
                    ')'
                  }
                  classes={{ tooltip: 'tooltip-noMaxWidth' }}
                  placement="bottom-end">
                  <div className={cx('pcSub-item')}>
                    <div className={cx('pcSub-count')}>
                      <span className={cx('count')}>{examListData.get('leakAllcount') + ' '}</span>
                      <span className={cx('size')}>
                        ({common.fileSizeTrans(examListData.get('leakAllsize')).common})
                      </span>
                    </div>
                  </div>
                </Tooltip>
              </div> */}
              </div>
            )}
        </Grid.Column>
        {commonVar.isDeclare === 1 && (
          <Grid.Column className={cx('cell-declare')}>
            <div className={cx('declare-area')}>
              <Tooltip
                title={
                  defineMessages(formatMessage({ id: 'Declare_4', defaultMessage: '신고한 대상자' })) +
                  ': ' +
                  (examListData.get('declare') > 0
                    ? examListData.get('declare') +
                    defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))
                    : defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' })))
                }
                classes={{ tooltip: 'tooltip-noMaxWidth' }}
                placement="bottom-end">
                <div className={cx('declare-box', { existDeclare: examListData.get('declare') > 0 })}>
                  <span className={cx('declare-title')}>
                    <Image
                      src={
                        examListData.get('declare') > 0 ? '/img/declare/declare_on.png' : '/img/declare/declare_off.png'
                      }
                    />
                  </span>
                  <span>{declareCount}</span>
                </div>
              </Tooltip>
            </div>
          </Grid.Column>
        )}
        {commonVar.isEdu === 1 && (
          <Grid.Column className={cx('cell-edu')}>
            <div className={cx('edu-area')}>
              <Tooltip
                title={
                  defineMessages(formatMessage({ id: 'Edu_20', defaultMessage: '연결된 교육' })) +
                  ': ' +
                  (examListData.get('edu') > 0
                    ? examListData.get('edu') +
                    defineMessages(formatMessage({ id: 'ExamListItem_10', defaultMessage: '개' }))
                    : defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' })))
                }
                classes={{ tooltip: 'tooltip-noMaxWidth' }}
                placement="bottom-end">
                <div className={cx('edu-box', { existEdu: examListData.get('edu') > 0 })}>
                  <span className={cx('edu-title')}>
                    <Image src={examListData.get('edu') > 0 ? '/img/edu/edu_on.png' : '/img/edu/edu_off.png'} />
                  </span>
                  <span>{eduCount}</span>
                </div>
              </Tooltip>
            </div>
          </Grid.Column>
        )}
      </Grid.Row>
    );

    return (
      <Segment
        vertical
        className={cx('examListItem-wrapper', {
          selected:
            selectedExamList.get('isType') === 'select' && selectedExamList.get('noArray').indexOf(itemNo) !== -1
        })}
        onClick={e => {
          e.stopPropagation();

          // e.shiftKey
          if (e.target.type !== 'checkbox' && e.target.className.indexOf('cell-checkBox') === -1) {
            handleSelectExamList(itemNo);
          } else {
            handleCheckExamList(itemNo, e.shiftKey);
          }
        }}>
        <Grid columns="equal" stackable style={{ padding: '2px 0px' }}>
          {InnerComponent}
        </Grid>
      </Segment>
    );
  }
}

export default injectIntl(ExamListItemAll);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamListItemAll.js